const voidTypes = [
  'image',
  'text-field',
  'video',
];

const isVoidType = (type) => voidTypes.includes(type);

export default isVoidType;
